import { lazyActivateTab, findTabByData } from 'owa-tab-store';
import { FloatingType } from '../store/schema/FloatingViewState';
import composeStore from '../store/composeStore';
import floatCompose from '../actions/floatCompose';

/**
 * Utility for opening a message that failed to send
 *
 * Opens the message in a tab if one exists. Otherwise, floats it.
 */
export function reopenFailedMessage(composeId: string) {
    const tab = findTabByData(composeId);
    if (tab) {
        lazyActivateTab.importAndExecute(tab);
    } else {
        floatCompose(composeStore.viewStates.get(composeId), FloatingType.Normal);
    }
}
